import { DataBean } from "../DataBean";

export class FamilyFuncionals extends DataBean {


    public async getFamilyCatalog(): Promise<any> {
        return this.getCustomService("PeopleArt", "java.util.List_getFamilyCatalog_Number", [null]);
    }
}